import React from "react";
import "./Order.scss";
function Order() {
  return (
    <div className="Order_header">
      <h1> Thank You for shopping !!! </h1>
    </div>
  );
}

export default Order;
